import { render, staticRenderFns } from "./real_beneficiary_declaration_form.vue?vue&type=template&id=810f979a&scoped=true"
import script from "./real_beneficiary_declaration_form.vue?vue&type=script&lang=js"
export * from "./real_beneficiary_declaration_form.vue?vue&type=script&lang=js"
import style0 from "./real_beneficiary_declaration_form.vue?vue&type=style&index=0&id=810f979a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810f979a",
  null
  
)

export default component.exports